import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { grinnellConfig } from "./data";

export default function GrinnellPage() {
  return <CityPageTemplate config={grinnellConfig} />;
}